import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import {
  isOrganisationDsoEntity,
  isSolutionEntity,
} from '@ipen-portal/ipen-entity-model';
import { TrpcApiBlueprint } from '@ipen-portal/plugin-trpc-react';

import { solutionProcessApiRef } from './apis';

export const solutionProcessPlugin = createFrontendPlugin({
  extensions: [
    TrpcApiBlueprint.make({
      name: 'solution-process-api',
      params: defineParams =>
        defineParams({
          apiRef: solutionProcessApiRef,
          path: 'solution-process',
        }),
    }),
    EntityCardBlueprint.make({
      name: 'used-solutions',
      params: {
        filter: isOrganisationDsoEntity,
        loader: async () =>
          import('./components/UsedSolutionsCard').then(m => (
            <m.UsedSolutionsCard />
          )),
        type: 'info',
      },
    }),

    EntityCardBlueprint.make({
      name: 'provided-solutions',
      params: {
        filter: isOrganisationDsoEntity,
        loader: async () =>
          import('./components/ProvidedSolutionsCard').then(m => (
            <m.ProvidedSolutionsCard />
          )),
        type: 'info',
      },
    }),

    EntityCardBlueprint.make({
      name: 'solution-provisioning',
      params: {
        filter: isSolutionEntity,
        loader: async () =>
          import('./components/SolutionProvisioningCard').then(m => (
            <m.SolutionProvisioningCard />
          )),
        type: 'info',
      },
    }),
  ],
  pluginId: 'solution-process',
});
